import { render, staticRenderFns } from "./ChatEscalateDialog.vue?vue&type=template&id=cdc7b7e2&"
import script from "./ChatEscalateDialog.vue?vue&type=script&lang=ts&"
export * from "./ChatEscalateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports